var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.29395 7.29365C2.90332 7.68428 2.90332 8.31865 3.29395 8.70928L9.29395 14.7093C9.68457 15.0999 10.3189 15.0999 10.7096 14.7093C11.1002 14.3187 11.1002 13.6843 10.7096 13.2937L5.41582 7.9999L10.7064 2.70615C11.0971 2.31553 11.0971 1.68115 10.7064 1.29053C10.3158 0.899902 9.68145 0.899902 9.29082 1.29053L3.29082 7.29053L3.29395 7.29365Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.2e716752e5ff4b8a6efe7b5b079f35e2.svg";
export { ForwardRef as ReactComponent };